var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isAvailable
    ? _c(
        "b-btn",
        {
          staticClass: "btn-card-action btn-card-action-light my-1",
          attrs: {
            to: {
              name: "ExternalPurchaseCreate",
              params: { mode: "create", id: _vm.purchase.id },
            },
          },
        },
        [
          _vm._v(" Закупить вне ИС "),
          _vm.purchase.flags.allow_external_purchase_expiration_date
            ? _c("span", { staticClass: "text-nowrap" }, [
                _vm._v(
                  "до " +
                    _vm._s(
                      _vm.getDateTimeFormat(
                        _vm.purchase.flags
                          .allow_external_purchase_expiration_date
                      )
                    )
                ),
              ])
            : _vm._e(),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }